import { RadioOptions } from './radio-options';
import { CheckboxOptions } from './checkbox-options';
import { OptionalMandatoryOptionsProps } from './types';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';

export function OptionalMandatoryOptions(props: OptionalMandatoryOptionsProps) {
  const { minimumSelections, maximumSelections } = props;
  const { t } = useTranslation(['patron_portal', 'common']);
  if (
    typeof minimumSelections !== 'number' ||
    typeof maximumSelections !== 'number'
  ) {
    return null;
  }
  let text = '';

  if (minimumSelections >= 1) {
    text = t('patron_portal.item_minimum_selection', {
      ns: 'patron_portal',
      minimumSelections,
      maximumSelections,
    });
  } else if (minimumSelections === maximumSelections) {
    text = t('patron_portal.item_minimum_selection_limit', {
      minimumSelections,
    });
  } else {
    text = t('patron_portal.item_selection_limit', { maximumSelections });
  }
  return (
    <>
      <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
        {text}
      </Typography>
      <CheckboxOptions {...props} />
    </>
  );
}

